export default "__VITE_ASSET__CN5dRxdH__"